import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/i18n/translations";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { ScrollToTop, SmoothScroll } from "@/components/SmoothScroll";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Home } from "@/pages/Home";
import { ChiSiamo } from "@/pages/ChiSiamo";
import { Ambiti } from "@/pages/Ambiti";
import { Attivita } from "@/pages/Attivita";
import { Iniziative } from "@/pages/Iniziative";
import { Lectiones } from "@/pages/Lectiones";
import { Master } from "@/pages/Master";
import { Pubblicazioni } from "@/pages/Pubblicazioni";
import { Contatti } from "@/pages/Contatti";
import { PrivacyPage, CookiePolicyPage } from "@/pages/Legali";

function App() {
  return (
    <ErrorBoundary>
      <I18nProvider>
        <BrowserRouter>
          <ScrollToTop />
          <SmoothScroll />
          <div className="flex min-h-screen flex-col">
            <Header />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/chi-siamo" element={<ChiSiamo />} />
                <Route path="/ambiti-di-ricerca" element={<Ambiti />} />
                <Route path="/attivita" element={<Attivita />} />
                <Route path="/attivita/iniziative" element={<Iniziative />} />
                <Route path="/attivita/lectiones" element={<Lectiones />} />
                <Route path="/attivita/master" element={<Master />} />
                <Route path="/attivita/pubblicazioni" element={<Pubblicazioni />} />
                <Route path="/contatti" element={<Contatti />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/cookie-policy" element={<CookiePolicyPage />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors />
      </I18nProvider>
    </ErrorBoundary>
  );
}

function NotFound() {
  return (
    <div className="container-x flex min-h-[60vh] flex-col items-center justify-center gap-4 py-24 text-center" data-testid="not-found-page">
      <span className="eyebrow text-bordeaux">404</span>
      <h1 className="font-serif text-4xl text-ink">Pagina non trovata</h1>
      <a href="/" className="text-sm font-semibold text-bordeaux underline">
        Torna alla Home
      </a>
    </div>
  );
}

export default App;
